import API from "@/services/api";
import { StablePriceResponse } from "../types/stablePrice";
import { Endpoints } from "./endpoints";


export const fetchStablePrice = async () => {
  return await new Promise<StablePriceResponse>(async (resolve, reject) => {
      API.get<StablePriceResponse>({
      endpoint: Endpoints.StablePrice,
    }).then(res => {
      resolve(res.promise.data);
    }).catch(res => {
      reject(res);
    });
  });
}

export default {
  fetchStablePrice
};


